import type { ConnectionPositionPair } from '@angular/cdk/overlay';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  output,
  inject,
  input,
} from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import type { CandidateSelectOption } from '@core/search-types';
import {
  ButtonComponent,
  ConnectedOverlayDirective,
  GroupComponent,
  IconButtonComponent,
  OverlayOriginDirective,
  RtStatefulComponent,
  TruncateComponent,
} from '@core/user-interface-legacy';

import { CandidateSelectDropdownComponent } from '../candidate-select-dropdown/candidate-select-dropdown.component';
import { CandidatesMultiSelectItemComponent } from '../candidates-multi-select-item/candidates-multi-select-item.component';

type State = {
  dropdownOpen: boolean;
};

@Component({
  selector: 'rt-candidate-select',
  templateUrl: './candidate-select.component.html',
  styleUrls: ['./candidate-select.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    GroupComponent,
    OverlayOriginDirective,
    IconButtonComponent,
    ButtonComponent,
    CandidatesMultiSelectItemComponent,
    TruncateComponent,
    ConnectedOverlayDirective,
    CandidateSelectDropdownComponent,
    TranslatePipe,
  ],
})
export class CandidateSelectComponent extends RtStatefulComponent<State> {
  protected readonly cdRef: ChangeDetectorRef;

  public readonly readOnly = input<boolean>(false);
  @Input() public value?: CandidateSelectOption;
  public valueChange = output<CandidateSelectOption | undefined>();

  public dropdownConfig: ConnectionPositionPair[] = [
    { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top' },
  ];

  constructor() {
    const cdRef = inject(ChangeDetectorRef);

    super(cdRef);
    this.cdRef = cdRef;

    this.createState({
      dropdownOpen: false,
    });
  }

  public toggleDropdown(dropdownOpen: boolean): void {
    this.setState({ ...this.state, dropdownOpen });
  }
}
